import React, { Component } from 'react';

import ReactPaginate from 'react-paginate';
import { Image } from 'semantic-ui-react';
import { Loading } from 'components';

import classNames from 'classnames/bind';
import styles from './ReactTablePagination.css';
const cx = classNames.bind(styles);

class ReactTablePagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentPage !== this.state.currentPage) {
      this.setState({ currentPage: 0 });
    }
  }

  handlePage = page => {
    const { handlePagination } = this.props;

    this.setState({ currentPage: page.selected });
    handlePagination(page.selected);
  };

  render() {
    const { currentPage, totalPages } = this.props;
    const { handlePage } = this;

    return (
      <div className={cx('react-pagenation-area')}>
        {this.state.currentPage === currentPage ? (
          <ReactPaginate
            forcePage={currentPage}
            pageCount={totalPages}
            pageRangeDisplayed={4}
            marginPagesDisplayed={1}
            onPageChange={handlePage}
            previousLabel={
              <div className={cx('image-wrap')}>
                <Image src="/img/table/paging_arrow_left.png" />
              </div>
            }
            nextLabel={
              <div className={cx('image-wrap')}>
                <Image src="/img/table/paging_arrow_right.png" />
              </div>
            }
            breakLabel={'. . .'}
            containerClassName={'react-pagenation'}
            pageClassName={'each-area'}
            pageLinkClassName={'each-area-link'}
            activeClassName={'active'}
          />
        ) : (
          <Loading active />
        )}
      </div>
    );
  }
}

export default ReactTablePagination;



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTablePagination.js